import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import {
  CREATIVE_ID,
  CROWDSOURCED_DEALS_EVENTS,
  FORM_MODAL_CREATIVE_ID,
} from 'site-modules/core-page/constants/crowdsourced-deals';

export function fireQuoteBotStartTracking({ detail: { value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_START,
    event_data: {
      action_name: TrackingConstant.ACTION_TOOL_SELECT,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      subaction_name: TrackingConstant.QUOTE_BOT_START,
      creative_id: CREATIVE_ID,
      value,
    },
  });
}

export function fireWidgetViewTracking() {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_WIDGET_VIEW,
    event_data: {
      action_name: TrackingConstant.ACTION_WIDGET_VIEW,
      action_cause: TrackingConstant.ACTION_CAUSE_SCROLL,
      creative_id: CREATIVE_ID,
    },
  });
}

export function fireSubmitFormTracking({ detail: { value, subactionName } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      subaction_name: subactionName,
      creative_id: FORM_MODAL_CREATIVE_ID,
      value,
    },
  });
}

function fireInputValidationTracking({ detail: { isValid, name } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: `${name}_input_${isValid ? 'success' : 'failure'}`,
      creative_id: FORM_MODAL_CREATIVE_ID,
    },
  });
}

export const CrowdsourcedDealsEngagementHandler = {
  init: () => {
    EventToolbox.on(CROWDSOURCED_DEALS_EVENTS.QUOTE_BOT_START, fireQuoteBotStartTracking);
    EventToolbox.on(CROWDSOURCED_DEALS_EVENTS.WIDGET_VIEW, fireWidgetViewTracking);
    EventToolbox.on(CROWDSOURCED_DEALS_EVENTS.SUBMIT_FORM, fireSubmitFormTracking);
    EventToolbox.on(CROWDSOURCED_DEALS_EVENTS.INPUT_VALIDATION, fireInputValidationTracking);
  },
};
